import type { QuickFilterConfig } from "../FilterBar.types";
import { SelectFilter } from "./filterTypes/SelectFilter";
import { MultiselectFilter } from "./filterTypes/MultiselectFilter";
import { CheckboxFilter } from "./filterTypes/CheckboxFilter";
import { RangeFilter } from "./filterTypes/RangeFilter";

export type QuickFilterVariant = "bar" | "modal";

export interface QuickFilterControlProps {
  config: QuickFilterConfig;
  value: unknown;
  onChange: (v: unknown) => void;
  /** "modal" uses light-background styles for use inside QuickFiltersModal */
  variant?: QuickFilterVariant;
}

export function QuickFilterControl({ config, value, onChange, variant = "bar" }: QuickFilterControlProps) {
  switch (config.type) {
    case "select":
      return <SelectFilter config={config} value={value} onChange={onChange} variant={variant} />;
    case "multiselect":
      return <MultiselectFilter config={config} value={value} onChange={onChange} variant={variant} />;
    case "checkbox":
      return <CheckboxFilter config={config} value={value} onChange={onChange} variant={variant} />;
    case "range":
      return <RangeFilter config={config} value={value} onChange={onChange} variant={variant} />;
    default:
      return null;
  }
}
